import { PageHeader } from '@/components/ui';
import { usePageTitleStore } from '@/stores/page-title';
import { Box } from '@chakra-ui/react';
import { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsSection, { type SettingsSectionProps } from '../components/SettingsSection';

type AccountSettingsPageShellProps = {
  titleKey: string;
  sectionTitleKey?: string;
  sectionDescriptionKey?: string;
  sectionLayout?: SettingsSectionProps['layout'];
  children: ReactNode;
};

const AccountSettingsPageShell = ({
  titleKey,
  sectionTitleKey,
  sectionDescriptionKey,
  sectionLayout,
  children,
}: AccountSettingsPageShellProps) => {
  const { t } = useTranslation();
  const setTitle = usePageTitleStore((state) => state.setTitle);
  const title = t(titleKey);

  useEffect(() => {
    setTitle(title);
    return () => setTitle('');
  }, [setTitle, title]);

  return (
    <Box maxW="1000px" w="full">
      <PageHeader title={title} titleSize="xl" marginBottom={4} />

      {sectionTitleKey ? (
        <SettingsSection
          title={t(sectionTitleKey)}
          description={sectionDescriptionKey ? t(sectionDescriptionKey) : undefined}
          layout={sectionLayout}
          isLast
        >
          {children}
        </SettingsSection>
      ) : (
        children
      )}
    </Box>
  );
};

export default AccountSettingsPageShell;
